import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Seo from '../components/Seo.jsx';
import { trackPixel } from '../lib/pixel.js';

const MERCH = [
  { name: 'Tote Bag',   category: 'Bags',        price: 'KShs 800', image: '/Assets/Product images/tote bags.jpg' },
  { name: 'Badges',     category: 'Accessories', price: 'KShs 250', image: '/Assets/Product images/badges.jpg' },
  { name: 'Bucket Hat', category: 'Accessories', price: 'KShs 500', image: '/Assets/Product images/bucket hat.jpg' },
  { name: 'T-shirt',    category: 'T Shirts',    price: 'KShs 500', image: '/Assets/Product images/t- shirts.jpg' },
];

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;

export default function Merch() {
  const [firstName, setFirstName] = useState('');
  const [email,     setEmail]     = useState('');
  const [status,    setStatus]    = useState('idle'); // idle | loading | success | error
  const [focused,   setFocused]   = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus('loading');
    try {
      const res = await fetch(`${SUPABASE_URL}/functions/v1/subscribe-newsletter`, {
        method:  'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ email: email.trim(), name: firstName.trim() }),
      });
      setStatus(res.ok ? 'success' : 'error');
      if (res.ok) trackPixel('Lead', { content_name: 'Newsletter' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#FFFFFF', fontFamily: "'Inter', sans-serif, sans-serif" }}>
      <Seo title="Shop" description="Drunken Lectures merch — tote bags, badges, bucket hats, and t-shirts." path="/merch" />
      <Navbar />

      {/* ── Hero ─────────────────────────────────────────────────────────────── */}
      <section style={{ paddingTop: '120px', paddingBottom: '5rem', textAlign: 'center', padding: '120px 1.5rem 5rem' }}>
        <div style={{ maxWidth: '680px', margin: '0 auto' }}>
          <div style={{
            display: 'inline-block',
            fontSize: '0.72rem', fontWeight: '700', letterSpacing: '0.14em',
            color: '#E8672E', textTransform: 'uppercase', marginBottom: '1.25rem',
          }}>
            The Drop
          </div>
          <h1 style={{
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
            fontSize: 'clamp(2.4rem, 6vw, 4rem)',
            fontWeight: '600',
            color: '#17140F',
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            margin: '0 0 1.25rem',
          }}>
            Merch Launching<br />
            <span className="accent-underline">Online Soon</span>
          </h1>
          <p style={{
            fontSize: '1.05rem', color: '#6B665C', lineHeight: 1.65,
            maxWidth: '480px', margin: '0 auto 0.75rem',
          }}>
            We're currently selling in person only — but the online store is on its way.
            Sign up below to be the first to know when we go live.
          </p>
          <p style={{ fontSize: '0.92rem', color: '#8A8577', margin: 0 }}>
            In person? Find us at our events.
          </p>
        </div>
      </section>

      {/* ── Merch grid ───────────────────────────────────────────────────────── */}
      <section style={{ padding: '0 1.5rem 6rem', background: '#FFFFFF' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div className="merch-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: '1.25rem',
          }}>
            {MERCH.map((item, i) => (
              <div key={i} style={{
                background: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
              }}>
                {/* Image + "In Person" badge */}
                <div style={{ position: 'relative', height: '300px', overflow: 'hidden' }}>
                  <img
                    loading="lazy"
                    decoding="async"
                    src={item.image}
                    alt={item.name}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                  <div style={{
                    position: 'absolute', top: '12px', left: '12px',
                    background: 'rgba(23,20,15,0.82)',
                    backdropFilter: 'blur(8px)',
                    color: 'white', fontSize: '0.68rem', fontWeight: '700',
                    letterSpacing: '0.08em', textTransform: 'uppercase',
                    padding: '5px 10px', borderRadius: '20px',
                  }}>
                    In Person Only
                  </div>
                </div>
                <div style={{ padding: '1.25rem 1.5rem 1.5rem' }}>
                  <h3 style={{ fontSize: '1.15rem', fontWeight: '700', color: '#17140F', margin: '0 0 0.25rem', letterSpacing: '-0.02em' }}>
                    {item.name}
                  </h3>
                  <p style={{ fontSize: '0.82rem', color: '#8A8577', margin: '0 0 0.6rem' }}>{item.category}</p>
                  <p style={{ fontSize: '1rem', fontWeight: '600', color: '#17140F', margin: 0 }}>{item.price}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Interest signup ───────────────────────────────────────────────────── */}
      <section style={{ padding: '5rem 1.5rem 7rem', background: '#1C3A56' }}>
        <div style={{ maxWidth: '520px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{
            fontSize: '0.72rem', fontWeight: '700', letterSpacing: '0.14em',
            color: '#E8672E', textTransform: 'uppercase', marginBottom: '1rem',
          }}>
            Get Notified
          </div>
          <h2 style={{
            fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', Arial, sans-serif",
            fontSize: 'clamp(1.8rem, 4vw, 2.5rem)',
            fontWeight: '600', color: 'white',
            letterSpacing: '-0.02em', lineHeight: 1.15,
            margin: '0 0 1rem',
          }}>
            Be first in line
          </h2>
          <p style={{ fontSize: '0.95rem', color: 'rgba(255,255,255,0.55)', lineHeight: 1.6, margin: '0 0 2.5rem' }}>
            Drop your email and we'll let you know the moment our online store goes live.
          </p>

          {status === 'success' ? (
            <div style={{
              padding: '1.5rem 2rem',
              background: 'rgba(232, 103, 46,0.12)',
              borderRadius: '12px',
              border: '1px solid rgba(232, 103, 46,0.25)',
            }}>
              <p style={{ color: '#E8672E', fontWeight: '700', fontSize: '1rem', margin: '0 0 0.4rem' }}>
                You're on the list!
              </p>
              <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.875rem', margin: 0 }}>
                We'll be in touch when the store launches.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '0.875rem' }}>
              <input
                type="text"
                placeholder="First name"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                style={{
                  ...fieldStyle,
                  borderColor: focused === 'name' ? 'rgba(255,255,255,0.45)' : 'rgba(255,255,255,0.15)',
                }}
                onFocus={() => setFocused('name')}
                onBlur={() => setFocused(null)}
              />
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{
                  ...fieldStyle,
                  borderColor: focused === 'email' ? 'rgba(255,255,255,0.45)' : 'rgba(255,255,255,0.15)',
                }}
                onFocus={() => setFocused('email')}
                onBlur={() => setFocused(null)}
              />
              {status === 'error' && (
                <p style={{ color: '#EF4444', fontSize: '0.8rem', margin: '0', textAlign: 'left' }}>
                  Something went wrong. Please try again.
                </p>
              )}
              <button
                type="submit"
                disabled={status === 'loading'}
                style={{
                  padding: '0.95rem',
                  background: status === 'loading' ? 'rgba(232, 103, 46,0.6)' : '#E8672E',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  fontWeight: '700',
                  letterSpacing: '0.04em',
                  cursor: status === 'loading' ? 'not-allowed' : 'pointer',
                  transition: 'background 0.2s ease',
                  fontFamily: "'Inter', sans-serif, sans-serif",
                }}
                onMouseEnter={e => { if (status !== 'loading') e.currentTarget.style.background = '#e85c28'; }}
                onMouseLeave={e => { if (status !== 'loading') e.currentTarget.style.background = '#E8672E'; }}
              >
                {status === 'loading' ? 'Sending…' : 'Notify me when you launch'}
              </button>
            </form>
          )}
        </div>
      </section>

      <Footer />

      <style>{`
        @media (max-width: 900px) { .merch-grid { grid-template-columns: repeat(2, 1fr) !important; } }
        @media (max-width: 500px) { .merch-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </div>
  );
}

const fieldStyle = {
  width: '100%',
  padding: '0.9rem 1.1rem',
  background: 'rgba(255,255,255,0.06)',
  border: '1px solid rgba(255,255,255,0.15)',
  borderRadius: '8px',
  color: 'white',
  fontSize: '0.925rem',
  fontFamily: "'Inter', sans-serif, sans-serif",
  outline: 'none',
  boxSizing: 'border-box',
  transition: 'border-color 0.2s ease',
};
